var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-cards',{attrs:{"useLocalPanels":"","localPanels":_vm.localPanels,"createChart":_vm.noop,"adjustChartOrder":_vm.noop,"editChart":_vm.noop}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }